import type { FaireProductEntity } from "../../entity_types/product";

export const p_rfvj5dhfm4: FaireProductEntity = {
  token: "p_rfvj5dhfm4",
  type: "product",
  name: "Eczema Relief for Kids",
  brandToken: "b_63rejl12p8",
  brandName: "Forces of Nature",
  imageUrl:
    "https://cdn.faire.com/fastly/7deca8d72ca211665e4cfcb5f4a229569f7768b006edd97d16c60f31e985456f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/93c4198104e670be70213d4abf090c230151cb58c4a4372eb167eef777f13d61.png",
    "https://cdn.faire.com/fastly/1e81e7680b7aa0e2ab2eeab63db68733d02c36cb834f58a7c7bb4cbf45b645ae.png",
    "https://cdn.faire.com/fastly/a1f9054a9200eb5d1636d3ce2e02e7eb9632e9d67ff9395ef8f8f370395f7902.png",
    "https://cdn.faire.com/fastly/95ef0cc268a69fbf48a11181ab2b40d67a40505e2710ecd20dcc0f33c6f33fd9.jpeg",
    "https://cdn.faire.com/fastly/5b10876f9b473f01c1f379e71c36febc4c286201033a580612c3090fd04ae50c.png",
    "https://cdn.faire.com/fastly/d30c9cec9767eb460315b3b649c1899cae07ec4b28af6b952f59951bdc41f11c.png",
    "https://cdn.faire.com/fastly/5125440d0f2ce2ca2a2c4a2ce2df7d2b561d25b7c4748b5b75ef9232604a588f.png",
    "https://cdn.faire.com/fastly/4b24f915d8683cda8fae4f9fe475feac18de09279387c4bb9663264d520c4dcf.png",
  ],
  priceDollars: 8.72,
  description:
    "Forces of Nature Eczema Kids offers fast, gentle relief from eczema symptoms including itching, redness, and dry, scaly patches. This blend of organic homeopathic medicines includes Hydrocotyle Asiatica (Pennywort) for its ability to calm irritated skin, Arctium Lappa (Burdock Root) and Iris Versicolor (Northern Blue Flag) for their anti-inflammatory properties. The targeted medicines are blended with organic essential oils, including German Chamomile and Niaouli, to speed absorption and nourish skin. Unlike conventional eczema creams that often rely on steroids or synthetic ingredients, our formula is gentle for daily use and sensitive skin, free of toxins and petroleum-based fillers.\n\nCertified Organic, Non-GMO Project Verified, and Leaping Bunny certified, Eczema Kids sets a higher standard for clean skin care. Choose this trusted natural solution designed to help your child feel comfortable in their skin again without compromising on ingredients.\n",
  tags: [],
  msrpDollars: 16.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:44.369Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
